import axios from 'axios';
import HTTPRequestConfig from './interfaces/RequestConfig';
import httpVerbsExport from './httpVerbs';
import Constants from '../../constants';
import logger from '@app/utils/logger';
import getAccessToken from '@app/utils/auth/getAccessToken';
import { resolveServiceUrl } from '../config';

export const ERROR_TYPE_CANCEL = 'ERR_CANCELED';

const setHeaders = (customHeaders: any) => {
  const client = axios.create({ baseURL: Constants.baseUrlPlaceholder });

  const access_token = getAccessToken();

  //common headers
  client.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
  client.defaults.headers.common['Content-Type'] = 'application/json';
  client.defaults.headers.common['Cache-Control'] = 'no-cache';
  client.defaults.headers.common['Pragma'] = 'no-cache';
  client.defaults.headers.common['Expires'] = '0';

  //custom header override
  // eg :- {authorization:"abcd123",Content-Type:"something"}
  for (let header in customHeaders) {
    switch (header) {
      case 'authorization':
        client.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
        break;
    }
  }

  return client;
};

const changeUrl = (req: HTTPRequestConfig) => {
  const { baseURL, url } = resolveServiceUrl(req.url ?? '', { includeTenant: true });

  req.url = url;
  if (baseURL) {
    req.baseURL = baseURL;
  }
};

const axiosApiClient = (options: HTTPRequestConfig, customHeaders?: any) => {
  const client = setHeaders(customHeaders ? customHeaders : {});

  changeUrl(options);

  const onSuccess = (data: any): any => {
    return data;
  };
  const onError = (error: any): any => {
    console.error('Request Failed:', error.config);
    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
      console.error('Headers:', error.response.headers);
    } else {
      console.error('Error Message:', error.message);
    }
    throw !(error?.response?.data instanceof Blob) && error?.response?.data ? error.response.data : error;
  };

  return client(options).then(onSuccess).catch(onError);
};

export const httpVerbs = httpVerbsExport;
export default axiosApiClient;
